/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function addVariantToCart(variant, quantity = 1) {
  let formData = {
    items: [
      {
        id: parseFloat(variant),
        quantity,
      },
    ],
  }
 
  if(document.querySelector(".cart-drawer__items")){
   document.querySelector(".cart-drawer__items").style.opacity = "0.5"
      document.querySelector('.cart-drawer__items').style.pointerEvents = "none"
  }

  if(document.querySelector(".order-summary__body")){
      document.querySelector(".order-summary__body").style.opacity = "0.5"
      document.querySelector(".order-summary__body").style.pointerEvents = "none"
  }
 

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then(response => {

      return response.json()

    }).then((data)=>{
      console.log("variant-add")
       document.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: !0,
          detail: { variant: data.items[0].id, quantity: 1 },
        })
      )
    })
    .catch(error => {
      console.error("Error:", error)
    })
}

function removeVariantFromCart(variant) {
  let updates = {
    [variant]: 0,
  }

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then(response => {
      if(document.querySelector(".cart-drawer__items")){
       document.querySelector(".cart-drawer__items").style.opacity = "0.5"
          document.querySelector('.cart-drawer__items').style.pointerEvents = "none"
      }
    
      if(document.querySelector(".order-summary__body")){
          document.querySelector(".order-summary__body").style.opacity = "0.5"
          document.querySelector(".order-summary__body").style.pointerEvents = "none"
      }
 
      setTimeout(() => {
        document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      )
      }, 500);
      
      return response.json()
    })
    .catch(error => {
      console.error("Error:", error)
    })
}


function cartUpdated() {
  fetch("/cart.js")
    .then(res => res.json())
    .then(data => {

      const shippingProtectionProductId = window.theme.shippingProtectionProductId
      if (shippingProtectionProductId) {
        const nonProtectionItems = data.items.filter(item => item.product_id !== shippingProtectionProductId)
        const protectionItem = data.items.find(item => item.product_id === shippingProtectionProductId)

        if (nonProtectionItems.length === 0 && protectionItem) {
          removeVariantFromCart(protectionItem.key)
          return
        }

        const variantId = document.querySelector('.shipping-protection-checkbox')?.value
        if (nonProtectionItems.length > 0 && !protectionItem && !sessionStorage.getItem('shipping_protection_removed') && variantId) {
          addVariantToCart(variantId, 1)
          return
        }
      }
      const enableFreeGift = window.theme.enableFreeGift
      const freeGiftThreshold = window.theme.freeGiftThreshold * 100
      const storedFreeGiftProduct = sessionStorage.getItem("free_gift_product")
      const freeGiftProduct = storedFreeGiftProduct ? storedFreeGiftProduct : window.theme.freeGiftProduct
      const freeGiftProductHandle = window.theme.freeGiftProductHandle
      const subtotal = data.items_subtotal_price
      const currentCartFreeGift = data.items.filter(item => item.handle == freeGiftProductHandle)
      const currentCartFreeGiftVariantId = currentCartFreeGift != undefined && currentCartFreeGift[0] != undefined ? currentCartFreeGift[0].key : null
      const alreadyInCart = data.items.some(item => item.handle == freeGiftProductHandle)
      const storedFreeGiftProductPrev = sessionStorage.getItem("free_gift_product_prev")
      const freeGiftProductPrevious = storedFreeGiftProductPrev ? storedFreeGiftProductPrev : window.theme.freeGiftProductOld
      const isFreeGiftPreviousStillInCart = data.items.some(item => item.id == freeGiftProductPrevious )
      const freeGiftRemoved = sessionStorage.getItem('free_gift_removed')
    
      if(freeGiftRemoved){
        /* If customer click remove button */
        return 
      } else {
        
      if (!enableFreeGift) {
        /* If free gift function is not enable */
        if (alreadyInCart) {
        /* If free gift function is not enable but free gift is in the cart */
          removeVariantFromCart(currentCartFreeGiftVariantId)
          return
        }
        return
      }
        
      if (!freeGiftProduct) {
          /* If Free Gift isn't set */
        return
      }
        
      if (subtotal < freeGiftThreshold) {
            /* If threshold is not reached reached */
        if (alreadyInCart) {
          /* If threshold is not reached but the cart has free gift */
          removeVariantFromCart(currentCartFreeGiftVariantId)
          return
         
        }
        
      } else {

        
        /* If threshold is reached */
        
        if (!alreadyInCart) {
          console.log('add product')
          
          /* If threshold is reached but gift is not in cart */
          /*
          if (currentCartFreeGiftVariantId) {
            removeVariantFromCart(currentCartFreeGiftVariantId)  
          }
          */
          addVariantToCart(freeGiftProduct)
          
          return
          
        } else {

           if (isFreeGiftPreviousStillInCart && freeGiftProduct != freeGiftProductPrevious) {
            /* If the free gift do not change to the same size, remove previous variant */
            removeVariantFromCart(freeGiftProductPrevious)
  
          }
          
               
          return
        }
      }
      }
    })
}

/* Quick Add Button For Mobile to show Variant */


document.addEventListener("click", event => {
  if (event.target.closest(".mobile_btn")) {
    event.target.closest(".mobile_btn").classList.toggle("active")
  }
})
  

document.addEventListener('line-item:will-change', ()=>{
    if(document.querySelector(".cart-drawer__items")){
   document.querySelector(".cart-drawer__items").style.opacity = "0.5"
      document.querySelector('.cart-drawer__items').style.pointerEvents = "none"
  }

  if(document.querySelector(".order-summary__body")){
      document.querySelector(".order-summary__body").style.opacity = "0.5"
      document.querySelector(".order-summary__body").style.pointerEvents = "none"
  }
 
})
document.addEventListener("variant:add", (e) => {
  console.log("variant:add")
   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
  }));
})

/*
document.addEventListener("cart:change", () => {
 
   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
  }));
})
  */


document.addEventListener("line-item:change", () => {
    console.log("line-item:change")
   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
  }));
})
  

document.addEventListener("cart:refresh", () => {
      console.log("cart-refresh")
  cartUpdated()
})


document.addEventListener("BB:SET:LOADING", ()=>{
     console.log("BB:SET:LOADING")
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
  }));
})

const freeGiftEnable = window.theme.enableFreeGift
if (freeGiftEnable) {
document.addEventListener('DOMContentLoaded', ()=>{
  
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
   }));
})
}

document.addEventListener("click", event => {

  if (event.target.closest(".free-gift__variant-update-button") || event.target.closest(".free-gift__variant-list-close-button")) {
    event.preventDefault()
    event.target.closest(".free-gift__variant-wrapper").querySelector(".free-gift__variants").classList.toggle("active")

    if (event.target.closest(".free-gift__variant-wrapper").querySelector(".free-gift__variants").classList.contains("active")) {
      event.target.closest(".free-gift__variant-wrapper").querySelector(".free-gift__variants").setAttribute("aria-hidden", false)
    } else {
      event.target.closest(".free-gift__variant-wrapper").querySelector(".free-gift__variants").setAttribute("aria-hidden", true)
    }
  }

  if (event.target.closest(".free-gift__variant-button")) {
      event.preventDefault()
      const variantId = event.target.dataset.variantId
      const variantOldId = event.target.closest(".free-gift__variant-wrapper").dataset.currentVariantId
      window.theme.freeGiftProductOld = variantOldId
      window.theme.freeGiftProduct = variantId
    
      sessionStorage.setItem("free_gift_product_prev", variantOldId)
      sessionStorage.setItem("free_gift_product", variantId)
      if(event.target.closest('.cart-drawer__items')){
        event.target.closest(".cart-drawer__items").style.opacity = "0.5"
      }
      if(event.target.closest('.order-summary__body')){
        event.target.closest(".order-summary__body").style.opacity = "0.5"
      }
    }

      if (event.target.closest('.line-item.free-gift .js-line-item-remove')){
      sessionStorage.setItem("free_gift_removed", true)
      }


})


/* Quick Add Variant Button to add to cart */

document.addEventListener("click", event => {
  if (event.target.closest(".product-item__variant-quick-add")) {
    const line_item = event.target.closest('line-item').dataset.variantFreeGift
    const button = event.target.closest(".product-item__variant-quick-add:not(.quantity_zero)")
    const variantId = button.getAttribute("data-variant-id")
    const quantity = 1

    if (line_item) {
      removeVariantFromCart(line_item)
    }
    
    addVariantToCart(variantId, quantity)
    
    if (window.location.pathname === "/cart" && !event.target.closest(".product-item__variant-quick-add").classList.contains("quantity_zero")) {
      document.querySelector(".container").scrollIntoView({ behavior: "smooth" })
    } else if (!event.target.closest(".product-item__variant-quick-add").classList.contains("quantity_zero")) {
      document.querySelector(".Drawer__FreeShippingBar").scrollIntoView({ behavior: "smooth" })
    }
  }
})



class ReadMore extends HTMLElement {
  constructor() {
    super()
    this.button = this.querySelector(".read-more__button")
    this.content = this.querySelector(".read-more__content")
  }

  connectedCallback() {
    this.button.addEventListener("click", () => {
      this.content.classList.toggle("read-more__content--open")
      this.button.classList.toggle("read-more__button--open")

      if(this.content.classList.contains('read-more__content--open')){
        this.content.setAttribute("aria-hidden", "false")
        this.button.textContent = "Read Less"
      } else {
        this.content.setAttribute("aria-hidden", "true")
        this.button.textContent = "Read More"
      }
    })
  }

}
if(!customElements.get("read-more")){
  customElements.define("read-more", ReadMore)
}


/* This is for shipping protection */

document.addEventListener("change", (event) => {
  if (event.target.matches(".checkbox-input")) {
    const checkbox = event.target;

    if (checkbox.closest(".shipping-protection-checkbox-wrapper")) {
      checkbox.disabled = true
      if (checkbox.checked) {
        sessionStorage.removeItem('shipping_protection_removed')
        addVariantToCart(checkbox.value, 1);
      } else {
        sessionStorage.setItem('shipping_protection_removed', 'true')
        removeVariantFromCart(checkbox.value);
      }
    }
  }
});

document.addEventListener("cart:refresh", () => {
  document.querySelectorAll(".shipping-protection-checkbox").forEach(cb => {
    cb.disabled = false
    if (sessionStorage.getItem('shipping_protection_removed')) cb.checked = false
  })
})

/* Shipping Protection End */
